import axios from 'axios';

const deleteWarehouseApi = async (token, id) => {
  const formData = new FormData();
  formData.append('stock_id', id);
  try {
    const res = await axios.post(
      '/Stock/delete',
      formData,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'applications/json',
          Authorization: 'Bearer ' + token,
          lang: 'ar'
        }
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export default deleteWarehouseApi;
